import styled from "@emotion/styled";
import { Paper, css } from "@mui/material";

type PaletteColor = "primary" | "secondary" | "success" | "error";

interface IconSquareButtonContainerProps {
  btncolor: PaletteColor;
  disabled?: boolean;
}

export const IconSquareButtonContainer = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "btncolor" && prop !== "disabled",
})<IconSquareButtonContainerProps>(({ theme, btncolor, disabled }) => {
  const baseColor = theme.palette[btncolor].main;
  const neutralBorder = theme.palette.divider;
  const neutralColor = theme.palette.text.secondary;

  return css`
    width: 28px;
    height: 28px;
    min-width: 28px;
    min-height: 28px;
    border-radius: 6px;
    padding: 0;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 1px solid ${neutralBorder};
    color: ${neutralColor};
    background-color: transparent;
    cursor: ${disabled ? "default" : "pointer"};
    opacity: ${disabled ? 0.5 : 1};
    transition: all 0.3s;

    svg {
      width: 16px;
      height: 16px;
    }

    &:hover {
      border-color: ${disabled ? neutralBorder : baseColor};
      color: ${disabled ? neutralColor : baseColor};
      box-shadow: ${disabled ? "none" : theme.shadows[1]};
      transform: ${disabled ? "none" : "translateY(-1px)"};
    }
  `;
});


